import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineOutlined from "@mui/icons-material/ErrorOutlineOutlined";
import { darken, lighten, useTheme } from "@mui/material/styles";
import type { FC } from "react";
import { Toaster } from "react-hot-toast";

export const AppToaster: FC = () => {
  const theme = useTheme();
  const isLightMode = theme.palette.mode === "light";
  const successBackground =
    theme.vars?.palette?.Alert?.successStandardBg ??
    (isLightMode
      ? lighten(theme.palette.success.light, 0.9)
      : darken(theme.palette.success.light, 0.9));
  const successText =
    theme.vars?.palette?.Alert?.successColor ??
    (isLightMode
      ? darken(theme.palette.success.light, 0.6)
      : lighten(theme.palette.success.light, 0.6));
  const successIcon = (
    <CheckCircleOutline sx={{ color: theme.palette.success.main, fontSize: 20 }} />
  );
  const errorBackground =
    theme.vars?.palette?.Alert?.errorStandardBg ??
    (isLightMode
      ? lighten(theme.palette.error.light, 0.9)
      : darken(theme.palette.error.light, 0.9));
  const errorText =
    theme.vars?.palette?.Alert?.errorColor ??
    (isLightMode
      ? darken(theme.palette.error.light, 0.6)
      : lighten(theme.palette.error.light, 0.6));
  const errorIcon = <ErrorOutlineOutlined sx={{ color: theme.palette.error.main, fontSize: 20 }} />;

  return (
    <Toaster
      toastOptions={{
        success: {
          style: {
            background: successBackground,
            color: successText,
          },
          icon: successIcon,
          iconTheme: {
            primary: successText,
            secondary: successBackground,
          },
        },
        error: {
          style: {
            background: errorBackground,
            color: errorText,
          },
          icon: errorIcon,
          iconTheme: {
            primary: errorText,
            secondary: errorBackground,
          },
        },
      }}
    />
  );
};
